import { render, staticRenderFns } from "./LayoutNavigation.vue?vue&type=template&id=389ca7a8&scoped=true&"
import script from "./LayoutNavigation.vue?vue&type=script&lang=js&"
export * from "./LayoutNavigation.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNavigation.vue?vue&type=style&index=0&id=389ca7a8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ca7a8",
  null
  
)

export default component.exports